/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { EEcmPanelStatus, EPlotType, IEcmDiagnosticError, IVehicleDiagnosticsResponse } from '../../models';

export interface IEcmPanelState {
  vehicleName: string;
  vehicleId: number | null;
  plotType: EPlotType | null;
  /** Lifecycle status of the panel (closed / loading / open). Drives whether the side panel is shown. */
  status: EEcmPanelStatus;
  diagnostics: IVehicleDiagnosticsResponse | null;
  /** Structured diagnostics errors returned by the backend (empty when there are none). */
  diagnosticsErrors: IEcmDiagnosticError[];
}

export const initialEcmPanelState: IEcmPanelState = {
  vehicleName: '',
  vehicleId: null,
  plotType: null,
  status: EEcmPanelStatus.Closed,
  diagnostics: null,
  diagnosticsErrors: []
};
